import React, { FC } from "react";
import Divider from "@material-ui/core/Divider";
import { makeStyles, Typography } from "@material-ui/core";
import { ApplicationStatus } from "../../modules/application/types";
import LabeledDot from "../LabeledDot/LabeledDot";

const useStyles = makeStyles(() => ({
  applications: {
    border: "1px solid #DBDBDB",
    borderRadius: 15,
    padding: "6px 16px",
    marginTop: 7,
    display: "flex",
    columnGap: "16px",
  },
  label: {
    fontSize: 14,
    color: "#a1a4ac",
  },
  applicationsText: {
    fontSize: 14,
    color: "#A1A4AC",
  },
  divider: {
    backgroundColor: "#DBDBDB",
    height: 21,
  },
}));

interface ApplicationsCountProps {
  name: string;
  approved: number;
  pending: number;
}

const ApplicationsCount: FC<ApplicationsCountProps> = ({
  name,
  approved,
  pending,
}) => {
  const classes = useStyles();

  return (
    <div>
      <Typography className={classes.label}>
        Under this {name} you have:
      </Typography>
      <div className={classes.applications}>
        <span className={classes.applicationsText}>Applications:</span>
        <LabeledDot
          color={ApplicationStatus.APPROVED}
          label={`Approved ${approved}`}
        />
        <Divider className={classes.divider} orientation={"vertical"} />
        <LabeledDot
          color={ApplicationStatus.PENDING}
          label={`Pending ${pending}`}
        />
      </div>
    </div>
  );
};

export default ApplicationsCount;
